module.exports = __webpack_public_path__ + "img/yth.689b1471.png";